import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Payment } from 'src/app/modules/entities/payment';
import { SubscriptionDetail } from 'src/app/modules/entities/subscription-detail';
import { PaymentService } from 'src/app/modules/services/payment.service';
import { errorDescription } from 'src/app/modules/util/constants';

@Component({
  selector: 'app-create-payment',
  templateUrl: './create-payment.component.html',
  styleUrls: ['./create-payment.component.css']
})
export class CreatePaymentComponent implements OnInit {

  constructor (private fb: FormBuilder, private messageService: MessageService, private paymentService: PaymentService) {
    this.paymentForm = this.fb.group({
      payDate: ['', [Validators.required]],
      method: ['', [Validators.required, Validators.maxLength(45)]],
      amount: [null, [Validators.required, Validators.minLength(5), Validators.maxLength(6),Validators.min(10000), Validators.max(999999), Validators.pattern('[0-9]+')]],
      additionalInfo: ['', [Validators.maxLength(150)]]
    });
  }

  @Input() displayDialog: boolean = false;
  @Output() displayDialogChange = new EventEmitter<boolean>();
  @Output() createdChange = new EventEmitter<boolean>();
  @Input() subscriptionDetail: SubscriptionDetail | undefined = undefined;
  paymentForm: FormGroup;

  ngOnInit(): void {
    this.paymentForm.get('payDate')?.setValue(new Date());
    this.paymentForm.get('method')?.setValue('Nequi');
  }

  closeDialog() {
    this.displayDialog = false;
    this.displayDialogChange.emit(this.displayDialog);
  }

  savePayment() {
    let payment: Payment = {
      payDate: this.paymentForm.get('payDate')?.value,
      method: this.paymentForm.get('method')?.value,
      amount: this.paymentForm.get('amount')?.value,
      currency: 'COP',
      additionalInfo: this.paymentForm.get('additionalInfo')?.value,
      subscriptionDetail: this.subscriptionDetail!
    }
    //payment.payDate.setHours(payment.payDate.getHours() - payment.payDate.getTimezoneOffset()/60);
    this.paymentService.savePayment(payment).subscribe({
      next: response => {
        if (response.status === 'success') {
          this.messageService.add({
            summary: 'Pago registrado',
            detail: 'El pago se registró correctamente',
            severity: response.status
          });
          this.createdChange.emit(true);
        } else {
          this.messageService.add({
            summary: 'Ocurrió un error registrando el pago',
            severity: response.status
          });
        }
        this.displayDialog = false;
      },
      error: error => {
        this.messageService.add({severity: 'error', detail: errorDescription[error.error.error]});
        this.displayDialog = false;
      }
    });
  }

}
